module.exports = __webpack_public_path__ + "img/616-cover.67c67a5e.jpg";